import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom';

export default function TeamEdit() {
    const history = useNavigate();

  const [file5, setFile5] = useState(null);
  const [inputval5, setinputVal5] = useState({
    teamimg:"",
    fname5: "",
    date: "",
    firstName:""
  });

  const setData = (e) => {
    const { name, value } = e.target;
    setinputVal5((Data) => {
      return {
        ...Data,
        [name]: value,
      };
    });
  };
  const { id } = useParams("");
  console.log(id);
  const getData = async () => {
    const res5 = await fetch(`https://pratik-agro-backend.vercel.app/getAboutTeamImg/${id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    const data3 = await res5.json();

    if (res5.status === 422 || !data3) {
      console.log("error");
    } else {
      console.log(data3);
    setinputVal5({
        teamimg: data3.teamimg,
      fname5: data3.fname5,
      date: data3.date,
      firstName:data3.firstName
    });
  }
  };
  useEffect(() => {
    getData();
  },[]);

  const updatedata5 = async (e) => {
    e.preventDefault();

    console.log(inputval5);

    var formData5 = new FormData();
    if (file5 != null) {
      formData5.append("image5", file5);
    }
    formData5.append("fname5", inputval5.fname5);
    formData5.append("date", inputval5.date);
    formData5.append("firstName", inputval5.firstName);
    for (var pair of formData5.entries()) {
      console.log(pair[0] + ", " + pair[1]);
    }

    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };

    axios
      .post(`https://pratik-agro-backend.vercel.app/updateAboutTeamimg/${id}`, formData5, config)
      .then((res) => {
        if (res.status === 201) {
          console.log(res.data);
          history("/Team_members");
        }
      })
      .catch((error) => {
        if (error.response) {
          console.log(error.response);
        }
      });
  };
  return (
    <div className='content'>
         <div className="container mt-5 ">
          <Link className="btn btn-dark" to="/Team_members">
          <i class="bi bi-arrow-left-circle-fill"></i>
          </Link>
        </div>

        <form className="mx-auto mt-5 shadow p-5">
          <div className="container ">
            <h6>Fill This Form:-</h6>
          </div>
          <div className="mb-3 w-50 ">
            <label className="form-label">Image:</label>
            <input
              type="file"
              className="form-control"
              id="exampleInputEmail1"
              aria-describedby="emailHelp"
              name="image5"
              onChange={(e) => setFile5(e.target.files[0])}
              value={inputval5.image5}
            />
          </div>
          <div className="mb-3 w-50 ">
            <label className="form-label">	Designation :</label>
            <input
              type="text"
              className="form-control"
              id="exampleInputEmail1"
              name="fname5"
              onChange={setData}
              value={inputval5.fname5}
            />
          </div>
          <div className="mb-3 w-50 ">
            <label className="form-label">	Name :</label>
            <input
              type="text"
              className="form-control"
              id="exampleInputEmail1"
              name="firstName"
              onChange={setData}
              value={inputval5.firstName}
            />
          </div>
          <div className="mb-3 w-50 ">
            <label className="form-label">Date:</label>
            <input
              type="text"
              className="form-control"
              id="exampleInputEmail1"
              aria-describedby="emailHelp"
              name="Description"
              onChange={setData}
              value={inputval5.date}
            />
          </div>
          <div>
            <Link className="btn btn-success  mt-3" onClick={updatedata5}>
              update Detail
            </Link>
          </div>
        </form>
    </div>
  )
}
